import React from 'react';

// A calm muted box used for empty/raw-fallback/error states inside the chart slot.
const ExplorerNotice = ({ children }) => (
  <div className="flex items-center justify-center min-h-[200px] rounded-lg border border-dashed border-gray-200 dark:border-gray-800 bg-gray-50/60 dark:bg-gray-900/30 px-6 py-10">
    <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-md">{children}</p>
  </div>
);

export default ExplorerNotice;
